import { createTheme } from '@mui/material/styles';
import { colors } from '@src/theme/colors';

import {
  BreakpointSize,
  DEFAULT_FONT_FAMILY,
} from '@constants/common/ui.constants';

const Theme = createTheme({
  palette: {
    custom: colors,
  },
  typography: {
    htmlFontSize: 14,
    fontSize: 16,
    fontFamily: DEFAULT_FONT_FAMILY,
    h1: {
      fontWeight: 500,
      fontSize: 48,
      fontFamily: 'EB Garamond, sans-serif',
      lineHeight: '48px',
    },
    h2: {
      fontWeight: 500,
      fontSize: 40,
      fontFamily: 'EB Garamond, sans-serif',
      lineHeight: '40px',
    },
    h3: {
      fontWeight: 500,
      fontSize: 28,
      lineHeight: '32px',
      fontFamily: 'EB Garamond, sans-serif',
    },
    h4: {
      fontWeight: 700,
      fontSize: 18,
      lineHeight: '24px',
    },
    subtitle1: {
      fontWeight: 600,
      fontSize: 16,
      lineHeight: '24px',
    },
    subtitle2: {
      fontWeight: 600,
      fontSize: 14,
      lineHeight: '20px',
    },
    body1: {
      fontWeight: 400,
      fontSize: 16,
      lineHeight: '24px',
    },
    body2: {
      fontWeight: 400,
      fontSize: 14,
      lineHeight: '20px',
    },
    overline1: {
      fontWeight: 400,
      fontSize: 14,
      lineHeight: '20px',
      textDecoration: 'underline',
    },
    caption1: {
      fontWeight: 400,
      fontSize: 12,
      lineHeight: '16px',
    },
    caption2: {
      fontWeight: 600,
      fontSize: 12,
      lineHeight: '16px',
    },
  },
  breakpoints: {
    values: {
      xs: BreakpointSize.Xs,
      sm: BreakpointSize.Sm,
      md: BreakpointSize.Md,
      lg: BreakpointSize.Lg,
      xl: BreakpointSize.Xl,
    },
  },
  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '16px',
    xlg: '20px',
    xl: '32px',
    xxl: '100px',
  },
  components: {
    MuiTypography: {
      defaultProps: {
        color: 'custom.text.dark',
      },
    },
  },
});

export default Theme;
